import CoreHomeHero from './CoreHomeHero';

export { type CoreHomeHeroProps } from './CoreHomeHero';
export default CoreHomeHero;
